/**
 * @file utils/timeUtil.js 时间相关的方法
 * @author zhangzhe(zhangzhe@baidu.com)
 */

import _ from 'lodash';
import moment from 'moment';

/**
 * 转为utc时间
 * @param {string|Object} time 时间字符串或者moment对象
 * @return {string} utc时间
 */

const timeToUtc = (time: moment.Moment | string) => {
    if (!time || (!_.isString(time) && !moment.isMoment(time))) {
        return null;
    }

    const t = moment.isMoment(time) ? time : moment(time);
    if (t.isValid()) {
        return t.utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    }
    return null;
};

function unitFormat(str: number) {
    return str < 10 ? '0' + str : str;
}

export default {
    getStartTime(date: moment.MomentInput) {
        return moment(date).format('YYYY-MM-DD 00:00:00');
    },
    getEndTime(date: moment.MomentInput) {
        return moment(date).format('YYYY-MM-DD 23:59:59');
    },
    getMonthFirstDay(d: moment.MomentInput) {
        return moment(d || new Date()).format('YYYY-MM-01');
    },
    timeToUtc(time: moment.Moment | string) {
        return timeToUtc(time);
    },
    // toUtcTime(utcTimeStr: string) {
    //     return utcTimeStr ? moment(utcTimeStr).utc().format('YYYY-MM-DD HH:mm:ss') : '';
    // },
    toTime(utcTimeStr: string, defaultTime = '') {
        return utcTimeStr ? moment(utcTimeStr).format('YYYY-MM-DD HH:mm:ss') : defaultTime;
    },
    utcToMinute(utcTimeStr: string, defaultTime = '') {
        return utcTimeStr ? moment(utcTimeStr).format('YYYY-MM-DD HH:mm') : defaultTime;
    },
    toDate(utcTimeStr: string, defaultTime = '') {
        return utcTimeStr ? moment(utcTimeStr).format('YYYY-MM-DD') : defaultTime;
    },
    // 检查是否是UTC格式参数
    // checkUTC(utcTime: string, isEndDate: boolean) {
    //     const utcFormat = /^[0-9]{4}-[0-1]?[0-9]{1}-[0-3]?[0-9]{1}T([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]Z$/;
    //     const dateFormat = /^[0-9]{4}-[0-1]?[0-9]{1}-[0-3]?[0-9]{1}$/;
    //     if (utcFormat.test(utcTime)) {
    //         return utcTime;
    //     }
    //     else if (dateFormat.test(utcTime)) {
    //         return moment(utcTime + (isEndDate ? ' 23:59:59' : '')).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    //     }

    //     return null;
    // },
    // checkTime(time: string, isEndDate: boolean) {
    //     const timeFormat = /^[0-9]{4}-[0-1]?[0-9]{1}-[0-3]?[0-9]{1}\s([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
    //     const dateFormat = /^[0-9]{4}-[0-1]?[0-9]{1}-[0-3]?[0-9]{1}$/;
    //     if (timeFormat.test(time)) {
    //         return time;
    //     }
    //     else if (dateFormat.test(time)) {
    //         return moment(time + (isEndDate ? ' 23:59:59' : '')).format('YYYY-MM-DD HH:mm:ss');
    //     }

    //     return null;
    // },

    /**
     * 将时间区间处理成开始日00:00:00-结束日23:59:59的utc格式
     *
     * @param {Array} timeRange 时间区间
     * @return {Array} 处理后的值
     */
    formatTimeRange(timeRange: Array<moment.Moment | string>) {
        timeRange = _.compact(timeRange);
        if (timeRange && timeRange.length === 2) {
            const newTimeRange = _.map(timeRange,
                (time: moment.Moment | string) => (moment.isMoment(time) ? time : moment(time)));
            return [
                timeToUtc(newTimeRange[0].format('YYYY-MM-DD 00:00:00')),
                timeToUtc(newTimeRange[1].format('YYYY-MM-DD 23:59:59'))
            ];
        }
        return [];
    },

    /**
     * 将秒数转化成形如“16:00:00” “01:02”类似时间展现形式
     *
     * @param {number | string} seconds 秒数
     * @return {string} 处理后的值
     */
    durationBySecond(seconds: number | string) {
        seconds = parseInt(seconds.toString(), 10);
        let hour: number = 0;
        let minute: number = 0;
        let second: number = 0;
        if (seconds <= 0) {
            return '00:00';
        }
        minute = Math.floor(seconds / 60);
        if (minute < 60) {
            second = seconds % 60;
            return unitFormat(minute) + ':' + unitFormat(second);
        }
        hour = Math.floor(minute / 60);
        minute = minute % 60;
        second = seconds - hour * 3600 - minute * 60;
        return unitFormat(hour) + ':' + unitFormat(minute) + ':' + unitFormat(second);
    }
};
